import React, { useEffect, useRef, useState } from "react";
import { linkify } from "../../utils/String";
import { Flex } from "../Flex";
import styled from "styled-components";
import { Button } from "../Button";
import { Spacing } from "../../theme/Spacing";
import { FontSize } from "../Text";
import { PSADetailsModal } from "./PSADetailsModal";
import { PSA } from "../../model/admin/AdminPSA";
import { useTranslation } from "react-i18next";

const Content = styled(Flex)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.sub};

  a {
    color: ${({ theme }) => theme.sub} !important;
    text-decoration: underline;
    text-underline-offset: 5px;
    margin-inline: 3px;
  }

  a:hover {
    color: ${({ theme }) => theme.darkSub} !important;
  }
`;

const StyledButton = styled(Button)`
  margin: 0;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 5px;
  background-color: transparent;
  margin-inline-start: ${Spacing.xs};
  font-size: ${FontSize.s};
  flex-shrink: 0;
`;

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.sub};
`;

type PSADescriptionProps = {
  psa: PSA;
};

export const PSADescription: React.FC<PSADescriptionProps> = ({ psa }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);

  const textRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const { description } = psa;

  const checkTruncate = () => {
    const el = textRef.current;
    if (!el) {
      return;
    }

    setIsTruncated(el.scrollWidth > el.clientWidth);
  };

  useEffect(() => {
    checkTruncate();
    window.addEventListener("resize", checkTruncate);

    return () => window.removeEventListener("resize", checkTruncate);
  }, [description]);

  return (
    <Flex width={"100%"}>
      <Content
        ref={textRef}
        dangerouslySetInnerHTML={{ __html: linkify(description!) }}
      />

      {isTruncated ? (
        <Flex flexShrink={0}>
          <StyledSpan>...</StyledSpan>

          <StyledButton onClick={() => setDetailsModalVisible(true)}>
            {t("common.readMore")}
          </StyledButton>
        </Flex>
      ) : null}

      <PSADetailsModal
        open={detailsModalVisible}
        onClose={() => setDetailsModalVisible(false)}
        psa={psa}
      />
    </Flex>
  );
};
